import React from 'react'
// import { TypeAnimation } from 'react-type-animation'
// import HeroBg from '../assets/hero-bg.png'

const ContactLanding = () => {
  return (
    <div className='hero-bg'>
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-md-12 text-white'>
            <h1 className='display-1 fw-bolder playfair-font'>
              “Frequently <b className='text-warning'>Ask Question”</b>{' '}
            </h1>
            <span>
              Get clarity on how to volunteer, donate, or partner with us.
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactLanding
